// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_3fDjIGYUBycXnlb7aLOrW_","chatMessagesDarkColor":"_2umd89EzNSE5iXB1-OYYxD","chatMessagesLightColor":"_2KV8zxmpzj6ZMenoqVhKGt"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/chat-messages/ChatMessages.css
// module id = 288
// module chunks = 0